// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/icons/context_menu.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%27100%27 height=%27100%27 viewBox=%270 0 100 100%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E %3Cstyle%3Epath%7Banimation:stroke 5s infinite linear%3B%7D%40keyframes stroke%7Bto%7Bstroke-dashoffset:776%3B%7D%7D%3C/style%3E%3ClinearGradient id=%27g%27 x1=%270%25%27 y1=%270%25%27 x2=%270%25%27 y2=%27100%25%27%3E%3Cstop offset=%270%25%27 stop-color=%27%2398FB98%27 /%3E%3Cstop offset=%2725%25%27 stop-color=%27%23A7F434%27 /%3E%3Cstop offset=%2750%25%27 stop-color=%27%23A7F434%27 /%3E%3Cstop offset=%27100%25%27 stop-color=%27%2332CD32%27 /%3E%3C/linearGradient%3E %3Cpath d=%27M1.5 1.5 l97 0l0 97l-97 0 l0 -97%27 stroke-linecap=%27square%27 stroke=%27url%28%23g%29%27 stroke-width=%273%27 stroke-dasharray=%27388%27/%3E %3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  --btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  --btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
  --dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;
}

:root {
  --filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  --btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  --btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
  --dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;
}

/* Скрывает только iframe оверлея ошибок, который вешается прямо на body */
body > iframe[style*="z-index: 2147483647"],
body > iframe[style*=fixed] {
  display: none !important;
}

/* Альтернативный селектор для новых версий react-error-overlay */
#webpack-dev-server-client-overlay,
div[style*="z-index: 2147483647"] {
  display: none !important;
}

:root {
  --filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  --btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  --btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
  --dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;
}

.appIcon {
  width: 1.5em;
  height: 1.5em;
}

.pageMainContainer {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  flex-grow: 1;
  align-self: stretch;
  overflow: auto;
}

.control__btn {
  position: absolute;
  bottom: 0.5em;
  right: 1.5em;
}

.btn_container {
  display: flex;
  gap: 2em;
  margin-bottom: 1em;
}
.btn_container.left {
  width: 100%;
  justify-content: flex-end;
}

.two-column-page__container {
  height: 100%;
  display: flex;
  position: relative;
  width: 100%;
}
.two-column-page__container .right-side {
  max-width: 50%;
  padding-left: 1%;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
}
.two-column-page__container .left-side {
  padding-right: 1%;
  border-right: 1px solid rgba(66, 108, 166, 0.1647058824);
  max-width: 50%;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
}
.two-column-page__container .save_btns {
  color: #567db8;
}
.two-column-page__container .save_btns button {
  margin-top: 10px;
  margin-left: 10px;
  font-weight: 400;
  color: #567db8;
  border: 0;
}
.two-column-page__container .save_btns button:disabled {
  color: rgba(86, 125, 184, 0.4117647059);
  background: rgba(218, 225, 236, 0.5411764706);
  cursor: default;
}
.two-column-page__container hr {
  border-top: 0.01px solid rgba(45, 109, 199, 0.3411764706);
  width: 100%;
  margin-left: 0;
  color: #426ba6;
}

.right_side_btn {
  margin: 0 0 0 auto;
}
.right_side_btn.bottom {
  margin: 0 0 1em auto;
}
.right_side_btn.top {
  margin: 1em 0 0 auto;
}
.right_side_btn.top_and_bottom {
  margin: 1em 0 1em auto;
}

@media (max-width: 1334px) {
  .create_kp_cof_buttons_row .right_side_btn {
    margin-left: 0;
    flex: 1 1 100%;
  }
}
.label {
  align-items: center;
}
.label_thin {
  color: #88a5cf;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  margin-right: 5px;
}
.label.underline {
  text-decoration: underline;
}
.label.autolabel {
  width: min-content;
  word-wrap: normal;
  overflow-wrap: normal;
  word-break: keep-all;
  white-space: nowrap; /* Запретить перенос текста по строчке */
  display: inline-block;
}

.autolabel label:not(.switch-custom__toggle) {
  width: min-content;
  word-wrap: normal;
  overflow-wrap: normal;
  word-break: keep-all;
  white-space: nowrap; /* Запретить перенос текста по строчке */
  display: inline-block;
  width: auto;
}

.overFlowAuto {
  overflow: auto;
}

.overflowX {
  overflow-x: auto;
}
.overflowXhidden {
  overflow-x: hidden;
}

.overflowY {
  overflow-y: auto;
}
.overflowYhidden {
  overflow-y: hidden;
}

.labelWrap {
  white-space: nowrap;
}

.tac {
  text-align: center;
}

.bgc {
  background-color: rgba(218, 225, 236, 0.5411764706);
}

.bgcActive {
  background-color: #bfcde2;
}

.project_form {
  height: 100%;
}

.list_container {
  width: 100%;
  height: 120px;
  overflow-x: hidden;
  background: #ffffff;
  margin-bottom: 5px;
  border: rgba(66, 108, 166, 0.5058823529);
}

.grid2_2 {
  display: grid;
  grid-template: 1fr 1fr/1fr 1fr;
}

.grid2_3 {
  display: grid;
  grid-template: 1fr 1fr/1fr 1fr 1fr 1fr;
}

.grid2_4 {
  display: grid;
  grid-template: 1fr 1fr/1fr 1fr 1fr 1fr;
  width: 100%;
  column-gap: 10px;
}

.grid2_4lastAuto {
  display: grid;
  grid-template: 1fr 1fr/1fr 1fr 1fr auto;
  width: 100%;
  column-gap: 10px;
}

.grid3_2 {
  display: grid;
  grid-template: 1fr 1fr/1fr 1fr 1fr;
}

.grid2_5 {
  display: grid;
  grid-template: 1fr 1fr/1fr 1fr 1fr 1fr 1fr;
  width: 100%;
  column-gap: 10px;
}

.grid2_5lastAuto {
  display: grid;
  grid-template: 1fr 1fr/1fr 1fr 1fr 1fr auto;
  width: 100%;
  column-gap: 1rem;
  row-gap: 1rem;
}

.gridTemplate2_4 {
  grid-template: 1fr 1fr/1fr 1fr 1fr auto;
}

.grid4col3Bigger {
  display: grid;
  grid-template-columns: repeat(2, 1fr) 2fr 1fr;
  gap: 10px;
}

.grid5col {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}

.projectDireciveListFiltersContainer {
  display: grid;
  column-gap: 20px;
  row-gap: 10px;
  width: 100%;
  grid-template-areas: "directiveNumber cofSecondNumber operationTypeId dateStart" "statusId sumPlan payerData payerData dateEnd";
  align-items: center;
  justify-items: end;
}

.invoiceListFiltersContainer {
  display: grid;
  column-gap: 20px;
  row-gap: 10px;
  width: 100%;
  grid-template-areas: "invoiceNumber clientId clientId coId dateStart" "sumPlan payerData payerData payerData dateEnd";
  align-items: center;
  justify-items: stretch;
}

.settingsVedListFiltersContainer {
  display: grid;
  column-gap: 20px;
  row-gap: 10px;
  width: 100%;
  grid-template-areas: "factoryId groupId typeId note dateStart" "countryId manager1Id manager2Id manager3Id dateEnd";
  align-items: center;
  justify-items: end;
}

.saleRulesFiltersContainer {
  display: grid;
  column-gap: 20px;
  row-gap: 10px;
  width: 100%;
  grid-template-areas: "typeK conditionType manager dateStart" "note note status dateEnd";
  align-items: center;
  justify-items: end;
}

.dealerDiscountListFiltersContainer {
  display: grid;
  column-gap: 20px;
  width: 50%;
  grid-template-areas: "fabricCoef fabricCoefCondition fabricCoef2 fabricCoefCondition2" "logistCoef logistCoefCondition logistCoef2 logistCoefCondition2" "renCoef renCoefCondition renCoef2 renCoefCondition2";
  align-items: center;
  justify-items: center;
}

.grid4col {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.gridTemplate2Rows {
  grid-template-rows: 1fr 1fr;
}

.gridTemplate2RowsFirstMin {
  grid-template-rows: 1fr 2fr;
}

.gridTemplate3ColsFirstMin {
  grid-template-columns: 1fr 2fr 2fr;
}

.grid2Col {
  display: grid;
  grid-template: 1fr/repeat(2, 1fr);
  column-gap: 10px;
  width: 100%;
}

.grid2ColWithDivider {
  display: grid;
  grid-template: 1fr/repeat(2, 1fr);
  column-gap: 10px;
  width: 100%;
  position: relative;
}
.grid2ColWithDivider::before {
  position: absolute;
  top: 5px;
  left: 50%;
  content: "";
  height: calc(100% - 10px);
  width: 1px;
  background-color: #a3b9d9;
}

.grid2ColFirstBigger {
  display: grid;
  grid-template: 1fr/2fr 1fr;
  column-gap: 10px;
  width: 100%;
}

.grid2ColSecondBigger {
  display: grid;
  grid-template: 2fr/1fr 1fr;
  column-gap: 10px;
  width: 100%;
}

.grid2ColSecondMax {
  display: grid;
  grid-template: 1fr/1fr auto;
  column-gap: 10px;
  width: 100%;
}

.grid3Col {
  display: grid;
  grid-template: 1fr/repeat(3, 1fr);
  column-gap: 10px;
  width: 100%;
}

.grid3ColMiddleMax {
  display: grid;
  grid-template: 1fr/auto 1fr auto;
  column-gap: 10px;
  width: 100%;
}

.grid3ColMiddleBigger {
  display: grid;
  grid-template: 1fr/1fr 2fr 1fr;
  column-gap: 10px;
  width: 100%;
}

.rowGap {
  row-gap: 1rem;
}

.grid3ColFirstMajor {
  display: grid;
  grid-template: 1fr/1.5fr repeat(2, 1fr);
  column-gap: 10px;
  width: 100%;
}

.jsfe {
  justify-self: flex-end;
}

.flex_form {
  display: flex;
  flex-direction: column;
}

.flex_container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.fc {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.fc {
  display: flex;
  align-items: center;
}
.fc.col {
  flex-direction: column;
}
.fc .fi50 {
  flex-basis: 50%;
}
.fc .fi60 {
  flex-basis: 60%;
}
.fc .fi70 {
  flex-basis: 70%;
}

.jsstr {
  justify-self: stretch;
}

.row {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 5px;
}

.flexWrap {
  flex-wrap: wrap;
}

.column {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  gap: 5px;
}

.relative {
  position: relative;
}

.capitalize {
  text-transform: capitalize;
}

.uppercase {
  text-transform: uppercase;
}

.w100 {
  width: 100%;
}

.mw100 {
  max-width: 100%;
}

.wh100 {
  width: 100%;
  height: 100%;
}

.w50 {
  width: 50%;
}

.h100 {
  height: 100%;
}

.maxH100 {
  max-height: 100%;
}

.inactive {
  background-color: transparent;
  color: rgba(86, 125, 184, 0.41);
}
.inactive table th {
  color: rgba(86, 125, 184, 0.41);
}

.fdr {
  display: flex;
  flex-direction: row;
}

.f_block {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.f_f_block {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1.8rem;
  width: 87%;
}

.f_f_block_small {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1.8rem;
}

.f_block_item_normal {
  flex-basis: calc(25% - 20px);
}

.f_block_item_less {
  flex-basis: calc(33% - 20px);
}

.f_item_opacity {
  opacity: 50%;
}

.fdc {
  display: flex;
  flex-direction: column;
}

.fcCol {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fcCols {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.fcc {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.nowrap {
  flex-wrap: nowrap;
}

.wrap {
  flex-wrap: wrap;
}

.space-between {
  justify-content: space-between;
}

.jcsb {
  justify-content: space-between;
}

.jcse {
  justify-content: space-evenly;
}

.jcsa {
  justify-content: space-around;
}

.jcc {
  justify-content: center;
}

.jcfe {
  justify-content: flex-end;
}

.jcfs {
  justify-content: flex-start;
}

.aic {
  align-items: center;
}

.aife {
  align-items: flex-end;
}

.aist {
  align-items: flex-start;
}

.aibl {
  align-items: baseline;
}

.aistr {
  align-items: stretch;
}

.asstr {
  align-self: stretch;
}

.asfs {
  align-self: flex-start;
}

.asfe {
  align-self: flex-end;
}

.asc {
  align-self: center;
}

.fd {
  flex-direction: column;
}

div.noGapDiv {
  gap: 0;
}

.noGap {
  gap: 0;
}

.asfs {
  align-self: flex-start;
}

.gap {
  gap: 1rem;
}

.gap0_5 {
  gap: 0.5rem;
}

.gap2x {
  gap: 2rem;
}

.gap3x {
  gap: 3rem;
}

.gap4x {
  gap: 4rem;
}

.gap5x {
  gap: 5rem;
}

.gap7x {
  gap: 7rem;
}

.gap10x {
  gap: 10rem;
}

.gap1 {
  gap: 1px;
}

.gap2 {
  gap: 2px;
}

.gap5 {
  gap: 5px;
}

.halfBasis {
  flex-basis: 50%;
}

.mba {
  margin-bottom: auto;
}

.mb0 {
  margin-bottom: 0;
}

.mb0_5 {
  margin-bottom: 0.5rem;
}

.mb {
  margin-bottom: 1rem;
}

.mb5 {
  margin-bottom: 5px;
}

.mb2x {
  margin-bottom: 2rem;
}

.mb3x {
  margin-bottom: 3rem;
}

.ml {
  margin-left: 1em;
}
.ml5 {
  margin-left: 5px;
}
.ml_05 {
  margin-left: 0.5em;
}
.ml2x {
  margin-left: 2em;
}
.ml3x {
  margin-left: 3em;
}
.ml_auto {
  margin-left: auto;
}

.mr {
  margin-right: 1em;
}
.mr_05 {
  margin-right: 0.5em;
}
.mr2x {
  margin-right: 2em;
}

.ml10em {
  margin-left: 10em;
}

.padding1 {
  padding: 1px;
}

.padding5 {
  padding: 5px;
}

.pt {
  padding-top: 1rem;
}
.pt0 {
  padding-top: 0;
}
.pt0_5 {
  padding-top: 0.5rem;
}
.pt3 {
  padding-top: 3px;
}
.pt5 {
  padding-top: 5px;
}
.pt2x {
  padding-top: 2rem;
}

.pb {
  padding-bottom: 1rem;
}
.pb0 {
  padding-bottom: 0;
}
.pb5 {
  padding-bottom: 5px;
}
.pb10 {
  padding-bottom: 10px;
}
.pb0_5 {
  padding-bottom: 0.5rem;
}
.pb1_5 {
  padding-bottom: 1.5rem;
}
.pb2x {
  padding-bottom: 2rem;
}

.pb2 {
  padding-bottom: 2rem;
}

.pl {
  padding-left: 1em;
}
.pl0 {
  padding-left: 0;
}
.pl5 {
  padding-left: 5px;
}
.pl_05 {
  padding-left: 0.5em;
}
.pl1_5x {
  padding-left: 1.5em;
}
.pl2x {
  padding-left: 2em;
}
.pl3x {
  padding-left: 3em;
}
.pl4x {
  padding-left: 4em;
}
.pl5x {
  padding-left: 5em;
}
.pl6x {
  padding-left: 6em;
}
.pl7x {
  padding-left: 7em;
}

.pr {
  padding-right: 1em;
}
.pr0 {
  padding-right: 0;
}
.pr5 {
  padding-right: 5px;
}
.pr_05 {
  padding-right: 0.5em;
}
.pr2x {
  padding-right: 2em;
}
.pr3x {
  padding-right: 3em;
}
.pr5x {
  padding-right: 5em;
}
.pr7x {
  padding-right: 7em;
}

.paddingRight {
  padding-right: 1rem;
}

.noShrink {
  flex-shrink: 0;
}

.fShrink {
  flex-shrink: 1;
}

.g2 {
  gap: 2em;
}

.g1 {
  gap: 1em;
}

.g15 {
  gap: 1.5em;
}

.fGrow {
  flex-grow: 1;
}

.fGrow2 {
  flex-grow: 2;
}

.fShrink {
  flex-shrink: 1;
}

.fShrink2 {
  flex-shrink: 2;
}

.fShrink2 {
  flex-shrink: 3;
}

.page_container {
  padding: 0 1em;
  padding-top: 5px;
  height: 100%;
}

.page_flex_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  justify-content: flex-start;
  gap: 1em;
}

.form_wrapper {
  width: 100%;
  min-width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: visible;
  position: relative;
}

.period-wrapper {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 10px;
}

.request-date-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 0;
  gap: 1.2em;
}

.flex0 {
  flex: 0 1;
}

.underlined {
  text-decoration: underline;
}

.borderInput {
  border: 1px solid rgba(66, 108, 166, 0.5058823529);
}

.borderLeft {
  border-left: 1px solid rgba(66, 108, 166, 0.5058823529);
}

.borderRight {
  border-right: 1px solid rgba(66, 108, 166, 0.5058823529);
}

.border_bottom_container {
  border-bottom: 1px solid rgba(66, 108, 166, 0.5058823529);
  width: 100%;
}

.padding {
  padding: 1rem;
}

.padding0_5 {
  padding: 0.5rem;
}

.margin0_5 {
  margin: 0.5rem;
}

.buttonPaddings {
  padding: 0.5rem 0.8rem 0.5rem 0.8rem;
}

.paddingMin {
  padding: 5px;
}

.paddingRight {
  padding-right: 1rem;
}

.paddingLeft {
  padding-left: 1rem;
}

.paddingTop {
  padding-right: 1rem;
}

.paddingBottom {
  padding-right: 1rem;
}

.br {
  border-radius: 3px;
}

.borderMiddle:not(:last-child) {
  border-right: 1px solid rgba(66, 108, 166, 0.5058823529);
}

.paddingMiddle {
  padding-right: 1em;
}
.paddingMiddle:not(:first-child) {
  padding-left: 1em;
}

.thin_border_container {
  border: 1px solid rgba(66, 108, 166, 0.5058823529);
}

.imgPreview {
  width: 100%;
  min-width: 600px;
  height: 100%;
  padding: 1em 2em;
  padding-bottom: 3em;
  box-sizing: border-box;
}

.previewBox {
  width: 100%;
  height: auto;
  min-height: 250px;
  max-width: 920px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 20px 20px;
  box-sizing: border-box;
  border: dashed 3px rgba(66, 108, 166, 0.368627451);
  border-radius: 10px;
  gap: 10px;
}

.previewBoxItem {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  object-fit: contain;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
  width: 200px;
  height: 200px;
}

.previewBoxItem__del {
  position: absolute;
  top: 0;
  right: -4px;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  width: 18px;
  height: 18px;
  background-color: aliceblue;
  font-size: 18px;
  line-height: 18px;
  font-weight: 300;
  margin-top: -5px;
  cursor: pointer;
}

.previewBoxItem__crop {
  position: absolute;
  bottom: 0;
  right: -4px;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  width: 18px;
  height: 18px;
  background-color: aliceblue;
  font-size: 18px;
  line-height: 18px;
  font-weight: 300;
  margin-top: -5px;
  cursor: pointer;
}

.previewBoxItem img {
  object-fit: cover;
}

.previewBoxItem.fileDeleted::after {
  content: "Deleted";
  position: absolute;
  top: 55%;
  left: 10%;
  font-size: 52px;
  transform: rotate(-45deg);
  width: 125px;
  color: #b72025;
}

.imgPreview__buttons {
  position: fixed;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  bottom: 10px;
  right: 5px;
  align-items: center;
}

.img-adding {
  border: 0;
}

.cropper_container {
  padding: 1em 2em;
  box-sizing: border-box;
}

.list {
  padding: 0;
  list-style: none;
}

.hideOverflow {
  overflow: hidden;
}

.scrollOverflow {
  overflow-y: scroll;
}

.centeredText {
  text-align: center;
}

.toBottom {
  margin-top: auto;
}

.mt {
  margin-top: 1rem;
}
.mt0 {
  margin-top: 0;
}

.mla {
  margin-left: auto;
}

.mra {
  margin-right: auto;
}

.mt5 {
  margin-top: 5px;
}

.mt0_5 {
  margin-top: 0.5rem;
}

.mt1x {
  margin-top: 1rem;
}

.mt2x {
  margin-top: 2rem;
}

.mt3x {
  margin-top: 3rem;
}

.mr {
  margin-right: 1rem;
}

.scrollY {
  overflow-y: auto;
}

.fullWidth {
  width: 100%;
}

.pr {
  position: relative;
}

.pa {
  position: absolute;
}

.dg {
  display: grid;
}

.col3 {
  grid-template-columns: repeat(3, 1fr);
}

.col4 {
  grid-template-columns: repeat(4, 1fr);
}

.col5 {
  grid-template-columns: repeat(5, 1fr);
}

.col4FirstBiggerLastSmaller {
  grid-template-columns: 2fr repeat(2, 1fr) 0.75fr;
}

.rows1 {
  grid-template-rows: 1fr;
}

.rows2 {
  grid-template-rows: repeat(2, 1fr);
}

.col3-proc {
  grid-template-columns: repeat(3, 32.5%);
  width: 100%;
}

.tac {
  text-align: center;
}

.tae {
  text-align: end;
}

.center {
  margin: auto;
}

.centerX {
  margin: 0 auto;
}

.bottom {
  margin-top: auto;
}

.h100 {
  height: 100%;
}

.modal_sizes {
  width: 89vw;
  min-height: 20vh;
}

.modal_sizes_preview {
  width: 91vw;
  min-height: 40vh;
}

.smallModal {
  width: 800px;
  min-height: 50vh;
}
@media screen and (min-width: 1800px) {
  .smallModal {
    min-height: 45vh;
  }
}
@media screen and (min-width: 2600px) {
  .smallModal {
    min-height: 40vh;
  }
}
.smallModal .modal_form__child {
  min-width: unset;
}

.largeModal {
  max-height: 90vh;
}
@media screen and (min-width: 1800px) {
  .largeModal {
    max-height: 80vh;
  }
}
@media screen and (min-width: 2600px) {
  .largeModal {
    max-height: 70vh;
  }
}
.largeModal .modal_form__child {
  flex-direction: column;
}

.xsModal {
  height: 300px;
  min-height: 300px;
}
.xsModal .modal_form__child {
  flex-direction: column;
  min-width: 700px;
}

.tabModal {
  height: 85%;
  max-height: 95%;
}
@media screen and (min-width: 1024px) {
  .tabModal {
    width: 85vw;
  }
}
@media screen and (min-width: 2600px) {
  .tabModal {
    width: 70vw;
  }
}

.largeTabModal {
  height: 95%;
}

@media screen and (min-width: 1024px) and (max-width: 1439px) {
  .smaller_font_size {
    font-size: 7px;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1799px) {
  .smaller_font_size {
    font-size: 11px;
  }
}
@media screen and (min-width: 1800px) {
  .smaller_font_size {
    font-size: 14px;
  }
}

.vertical-line {
  position: relative;
  width: 1px; /* Ширина линии */
  height: 100%; /* Высота линии */
  background-color: rgba(66, 108, 166, 0.5058823529); /* Цвет линии */
}

.vertical-line::after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%; /* Расположение линии по центру */
  transform: translateX(-50%);
  height: 100%;
  width: 1px;
  background-color: rgba(66, 108, 166, 0.5058823529);
}

.hidden {
  overflow: hidden;
}

.hiddenEl {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  clip: rect(0 0 0 0);
}

.borderedInput {
  border: 1px solid rgba(66, 108, 166, 0.5058823529);
}

.inputTypeNumberNoArrows::-webkit-outer-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  margin: 0;
}
.inputTypeNumberNoArrows::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  margin: 0;
}

.accented {
  transition: box-shadow 0.3s cubic-bezier(0.25, 1, 0.5, 1);
  border: 1px solid #ff073a;
  box-shadow: rgba(255, 7, 58, 0.25) 1px 2px 2px;
}
.accented:hover {
  box-shadow: rgba(255, 7, 58, 0.25) 2px 4px 4px, rgba(255, 7, 58, 0.12) -2px -3px 3px, rgba(255, 7, 58, 0.12) 0px 4px 4px, rgba(255, 7, 58, 0.17) 0px 4px 4px, rgba(255, 7, 58, 0.09) 0px -3px 3px;
}

.accentedIcon {
  fill: #b72025;
}

.header {
  font-weight: 500;
  text-decoration: underline;
}

.fitContentWidth {
  width: -moz-fit-content;
  width: fit-content;
}

.l0 {
  left: 0;
}

.t0 {
  top: 0;
}

.leftPlaceholder::placeholder {
  text-align: left;
}

.italic {
  font-style: italic;
}

.small-text {
  font-size: 12px;
  font-weight: 300;
}

.disabled-div {
  pointer-events: none;
  opacity: 0.5;
}

.blur {
  opacity: 0.5;
  pointer-events: none;
}

.blurWithEvents {
  opacity: 0.5;
}

.accentedTableCell {
  background-color: #d6dde7;
  color: #567db8;
}

.accentedRedTableCell {
  color: #b72025;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.pulse {
  animation: pulse 1.5s infinite ease-in-out;
}

.p0 {
  padding: 0;
}

.absolute {
  position: absolute;
  top: 0;
  left: 0;
}

.absolute.right {
  right: 0;
  left: unset;
}

.absolute.left {
  left: 0;
  right: unset;
}

.absolute.top {
  top: 0;
  bottom: unset;
}

.absolute.bottom {
  bottom: 0;
  top: unset;
}

.readOnlyInput {
  pointer-events: none;
}

.accentBtn {
  border: 1px solid #b72025;
  box-shadow: 3px 3px 1px #b72025;
  transition: border 0.2s ease-out, box-shadow 0.2s ease-out;
}

@keyframes temporaryAccentFade {
  0%, 60% {
    outline-color: #b72025;
    box-shadow: 3px 3px 1px #b72025;
  }
  100% {
    outline-color: transparent;
    box-shadow: none;
  }
}
.temporaryAccentBtn {
  outline: 1px solid #b72025;
  animation: temporaryAccentFade 4s ease-out forwards;
}

@media (prefers-reduced-motion: reduce) {
  .temporaryAccentBtn {
    animation-duration: 0.01ms;
  }
}
.normalWeight {
  font-weight: 400;
}

.pointer {
  cursor: pointer;
}

.contextMenuCursor {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), pointer;
}

.sticky {
  position: sticky;
  top: 0;
  left: 0;
}

.relative {
  position: relative;
}

.fixed {
  position: fixed;
  top: 0;
  left: 0;
}

.btnNoFuntional {
  opacity: 50%;
}

.filtersTopContainer {
  border-radius: 5px;
  padding: 2px 10px 10px 2px;
  position: relative;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  transition: box-shadow 0.35s cubic-bezier(0.075, 0.82, 0.565, 1);
}
.filtersTopContainer:hover {
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
}
.filtersTopContainer:hover .filtersTitle {
  background-color: #fff;
}
.filtersTopContainer .filtersTitle {
  position: absolute;
  color: #426ba6;
  top: -7px;
  left: 80px;
  font-size: 12px;
  padding: 1px 5px;
  border-radius: 5px;
  transition: background-color 0.35s cubic-bezier(0.075, 0.82, 0.565, 1);
}

.snakePdfPreviewBorder {
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 1;
}

.stickyTableRowItem {
  position: sticky;
  left: 0;
  z-index: 20;
  background-color: white;
}

.accent-row {
  background-color: #567db8;
  color: white;
}

.accent-cell {
  border: 1px solid #b72025;
}

.notesTable {
  overflow-x: auto;
  height: 5rem;
  border: 1px solid rgba(163, 185, 217, 0.5960784314);
  font-style: italic;
  padding-left: 8px;
}

.noteTableContact {
  height: 4rem;
}

.notesTable.factory-new-contact-notes-table {
  height: 5.25em;
}

.notesTableTr {
  cursor: pointer;
}
.notesTableTr td {
  white-space: wrap;
}

.note-block {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.5em;
}

.transitionAll {
  transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}

.commonShadow {
  box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;
}
.commonShadow:hover {
  box-shadow: rgba(67, 71, 85, 0.27) 1px 1px 0.25em, rgba(90, 125, 188, 0.05) 1px 0.3em 1em;
}

input[type=radio]:disabled {
  opacity: 0.5;
}

.styles-table {
  height: 44rem;
}

.date-delivery {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.history-box {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.manager-btn-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 9rem;
  justify-content: space-between;
  margin-bottom: 1rem;
  height: 100%;
}

.orderFullSection-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 340px;
  grid-template-rows: auto 1fr;
  gap: 0 1rem;
}

.cicle-check {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 17px;
  height: 17px;
  border-radius: 100%;
  background-color: #fff;
}

.cicle-disabled {
  background-color: transparent;
}

.visually-hidden {
  position: absolute;
  white-space: nowrap;
  width: 1px;
  height: 1px;
  overflow: hidden;
  border: 0;
  padding: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(100%);
  margin: -1px;
}

.w50p {
  width: 50%;
}

.question-input {
  display: flex;
  align-items: center;
  justify-content: center;
  top: 1px;
  left: 1px;
  margin-left: 0;
}

.accentText {
  color: #b72025;
}

.widthUnset {
  width: unset;
}

.defaultCursor {
  cursor: default;
}

.notAllowedCursor {
  cursor: not-allowed;
}

.mta {
  margin-top: auto;
}

.required-asterisk {
  color: #b72025;
}

.shipment-data {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.minWidthUnset {
  min-width: unset;
}

.context-menu-text {
  color: #426ba6;
  font-weight: 400;
  cursor: pointer;
  font-size: 1.1em;
}

.hoverRow:hover {
  background-color: rgba(66, 108, 166, 0.1843137255);
}`, "",{"version":3,"sources":["webpack://./src/Styles/Main.scss","webpack://./src/Components/App/vars.scss","webpack://./src/Components/App/index.scss"],"names":[],"mappings":"AAAA,gBAAgB;AC8ChB;EACE,sDAAA;EACA,0DAAA;EACA,2GAAA;EACA,kDAAA;AD5CF;;ACwCA;EACE,sDAAA;EACA,0DAAA;EACA,2GAAA;EACA,kDAAA;ADrCF;;AETA,0EAAA;AACA;;EAEE,wBAAA;AFYF;;AETA,iEAAA;AACA;;EAEE,wBAAA;AFYF;;ACqBA;EACE,sDAAA;EACA,0DAAA;EACA,2GAAA;EACA,kDAAA;ADlBF;;AA7BA;EACE,YAAA;EACA,aAAA;AAgCF;;AA9BA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAiCF;;AA/BA;EACE,kBAAA;EACA,aAAA;EAEA,YAAA;AAiCF;;AA/BA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AAkCF;AAjCE;EACE,WAAA;EACA,yBAAA;AAmCJ;;AAhCA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAmCF;AAjCE;EACE,cAAA;EACA,gBAAA;EAEA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;AAkCJ;AAhCE;EACE,iBAAA;EACA,wDAAA;EACA,cAAA;EAEA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;AAiCJ;AA/BE;EACE,cAAA;AAiCJ;AAhCI;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAkCN;AAjCM;EACE,uCAAA;EACA,6CAAA;EACA,eAAA;AAmCR;AA/BE;EACE,yDAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AAiCJ;;AA9BA;EACE,kBAAA;AAiCF;AAhCE;EACE,oBAAA;AAkCJ;AAhCE;EACE,oBAAA;AAkCJ;AAhCE;EACE,sBAAA;AAkCJ;;AA9BA;EAEI;IACE,cAAA;IACA,cAAA;EAgCJ;AACF;AA3BA;EACE,mBAAA;AA6BF;AA5BE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA8BJ;AA5BE;EACE,0BAAA;AA8BJ;AA5BE;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA,EAAA,wCAAA;EACA,qBAAA;AA8BJ;;AA1BE;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA,EAAA,wCAAA;EACA,qBAAA;EACA,WAAA;AA6BJ;;AAzBA;EACE,cAAA;AA4BF;;AAzBA;EACE,gBAAA;AA4BF;AA1BE;EACE,kBAAA;AA4BJ;;AAzBA;EACE,gBAAA;AA4BF;AA1BE;EACE,kBAAA;AA4BJ;;AAxBA;EACE,mBAAA;AA2BF;;AAxBA;EACE,kBAAA;AA2BF;;AAlBA;EACE,mDAAA;AAqBF;;AAnBA;EACE,yBAAA;AAsBF;;AAnBA;EACE,YAAA;AAsBF;;AAnBA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,wCAAA;AAqBF;;AAjBA;EACE,aAAA;EACA,8BAAA;AAoBF;;AAlBA;EACE,aAAA;EACA,sCAAA;AAqBF;;AAnBA;EACE,aAAA;EACA,sCAAA;EACA,WAAA;EACA,gBAAA;AAsBF;;AApBA;EACE,aAAA;EACA,uCAAA;EACA,WAAA;EACA,gBAAA;AAuBF;;AArBA;EACE,aAAA;EACA,kCAAA;AAwBF;;AAtBA;EACE,aAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;AAyBF;;AAvBA;EACE,aAAA;EACA,2CAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AA0BF;;AAxBA;EACE,uCAAA;AA2BF;;AAzBA;EACE,aAAA;EACA,6CAAA;EACA,SAAA;AA4BF;;AA1BA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AA6BF;;AA1BA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,+HACE;EAEF,mBAAA;EACA,kBAAA;AA2BF;;AAxBA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,qHACE;EAEF,mBAAA;EACA,sBAAA;AAyBF;;AAtBA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,mHACE;EAEF,mBAAA;EACA,kBAAA;AAuBF;;AApBA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,uFACE;EAEF,mBAAA;EACA,kBAAA;AAqBF;;AAlBA;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,8MACE;EAGF,mBAAA;EACA,qBAAA;AAkBF;;AAfA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAkBF;;AAfA;EACE,2BAAA;AAkBF;;AAhBA;EACE,2BAAA;AAmBF;;AAjBA;EACE,kCAAA;AAoBF;;AAXA;EACE,aAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;AAcF;;AAZA;EACE,aAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAeF;AAbE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,yBAAA;AAeJ;;AAZA;EACE,aAAA;EACA,0BAAA;EACA,gBAAA;EACA,WAAA;AAeF;;AAbA;EACE,aAAA;EACA,0BAAA;EACA,gBAAA;EACA,WAAA;AAgBF;;AAdA;EACE,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,WAAA;AAiBF;;AAfA;EACE,aAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;AAkBF;;AAhBA;EACE,aAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;AAmBF;;AAjBA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;AAoBF;;AAlBA;EACE,aAAA;AAqBF;;AAlBA;EACE,aAAA;EACA,uCAAA;EACA,gBAAA;EACA,WAAA;AAqBF;;AAnBA;EACE,sBAAA;AAsBF;;AAlBA;EACE,aAAA;EACA,sBAAA;AAqBF;;AAlBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAqBF;;AAnBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAsBF;;AAnBA;EACE,aAAA;EACA,mBAAA;AAsBF;AAnBE;EACE,sBAAA;AAqBJ;AAlBE;EACE,eAAA;AAoBJ;AAlBE;EACE,eAAA;AAoBJ;AAlBE;EACE,eAAA;AAoBJ;;AAjBA;EACE,qBAAA;AAoBF;;AAlBA;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;EAEA,QAAA;AAoBF;;AAlBA;EACE,eAAA;AAqBF;;AAnBA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;AAsBF;;AAnBA;EACE,kBAAA;AAsBF;;AApBA;EACE,0BAAA;AAuBF;;AApBA;EACE,yBAAA;AAuBF;;AApBA;EACE,WAAA;AAuBF;;AArBA;EACE,eAAA;AAwBF;;AArBA;EACE,WAAA;EACA,YAAA;AAwBF;;AArBA;EACE,UAAA;AAwBF;;AArBA;EACE,YAAA;AAwBF;;AArBA;EACE,gBAAA;AAwBF;;AArBA;EACE,6BAAA;EACA,+BAAA;AAwBF;AAtBE;EACE,+BAAA;AAwBJ;;AApBA;EACE,aAAA;EACA,mBAAA;AAuBF;;AApBA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;AAuBF;;AApBA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AAuBF;;AApBA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAuBF;;AApBA;EACE,4BAAA;AAuBF;;AApBA;EACE,4BAAA;AAuBF;;AApBA;EACE,YAAA;AAuBF;;AApBA;EACE,aAAA;EACA,sBAAA;AAuBF;;AApBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAuBF;;AArBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAwBF;;AArBA;EACE,aAAA;EAEA,mBAAA;EACA,mBAAA;AAuBF;;AArBA;EACE,iBAAA;AAwBF;;AAtBA;EACE,eAAA;AAyBF;;AAvBA;EACE,8BAAA;AA0BF;;AAxBA;EACE,8BAAA;AA2BF;;AAzBA;EACE,6BAAA;AA4BF;;AA1BA;EACE,6BAAA;AA6BF;;AA3BA;EACE,uBAAA;AA8BF;;AA5BA;EACE,yBAAA;AA+BF;;AA7BA;EACE,2BAAA;AAgCF;;AA9BA;EACE,mBAAA;AAiCF;;AA/BA;EACE,qBAAA;AAkCF;;AAhCA;EACE,uBAAA;AAmCF;;AAjCA;EACE,qBAAA;AAoCF;;AAlCA;EACE,oBAAA;AAqCF;;AAnCA;EACE,mBAAA;AAsCF;;AApCA;EACE,sBAAA;AAuCF;;AArCA;EACE,oBAAA;AAwCF;;AAtCA;EACE,kBAAA;AAyCF;;AAvCA;EACE,sBAAA;AA0CF;;AAxCA;EACE,MAAA;AA2CF;;AAzCA;EACE,MAAA;AA4CF;;AA1CA;EACE,sBAAA;AA6CF;;AA3CA;EACE,SAAA;AA8CF;;AA5CA;EACE,WAAA;AA+CF;;AA7CA;EACE,SAAA;AAgDF;;AA9CA;EACE,SAAA;AAiDF;;AA/CA;EACE,SAAA;AAkDF;;AAhDA;EACE,SAAA;AAmDF;;AAjDA;EACE,SAAA;AAoDF;;AAlDA;EACE,UAAA;AAqDF;;AAnDA;EACE,QAAA;AAsDF;;AApDA;EACE,QAAA;AAuDF;;AArDA;EACE,QAAA;AAwDF;;AAtDA;EACE,eAAA;AAyDF;;AAvDA;EACE,mBAAA;AA0DF;;AAxDA;EACE,gBAAA;AA2DF;;AAzDA;EACE,qBAAA;AA4DF;;AA1DA;EACE,mBAAA;AA6DF;;AA3DA;EACE,kBAAA;AA8DF;;AA5DA;EACE,mBAAA;AA+DF;;AA7DA;EACE,mBAAA;AAgEF;;AA9DA;EACE,gBAAA;AAiEF;AAhEE;EACE,gBAAA;AAkEJ;AAhEE;EACE,kBAAA;AAkEJ;AAhEE;EACE,gBAAA;AAkEJ;AAhEE;EACE,gBAAA;AAkEJ;AAhEE;EACE,iBAAA;AAkEJ;;AA/DA;EACE,iBAAA;AAkEF;AAjEE;EACE,mBAAA;AAmEJ;AAjEE;EACE,iBAAA;AAmEJ;;AAhEA;EACE,iBAAA;AAmEF;;AAjEA;EACE,YAAA;AAoEF;;AAjEA;EACE,YAAA;AAoEF;;AAjEA;EACE,iBAAA;AAoEF;AAlEE;EACE,cAAA;AAoEJ;AAlEE;EACE,mBAAA;AAoEJ;AAlEE;EACE,gBAAA;AAoEJ;AAlEE;EACE,gBAAA;AAoEJ;AAlEE;EACE,iBAAA;AAoEJ;;AAjEA;EACE,oBAAA;AAoEF;AAlEE;EACE,iBAAA;AAoEJ;AAlEE;EACE,mBAAA;AAoEJ;AAlEE;EACE,oBAAA;AAoEJ;AAlEE;EACE,sBAAA;AAoEJ;AAlEE;EACE,sBAAA;AAoEJ;AAlEE;EACE,oBAAA;AAoEJ;;AAhEA;EACE,oBAAA;AAmEF;;AAjEA;EACE,iBAAA;AAoEF;AAnEE;EACE,eAAA;AAqEJ;AAnEE;EACE,iBAAA;AAqEJ;AAnEE;EACE,mBAAA;AAqEJ;AAnEE;EACE,mBAAA;AAqEJ;AAnEE;EACE,iBAAA;AAqEJ;AAnEE;EACE,iBAAA;AAqEJ;AAnEE;EACE,iBAAA;AAqEJ;AAnEE;EACE,iBAAA;AAqEJ;AAnEE;EACE,iBAAA;AAqEJ;AAnEE;EACE,iBAAA;AAqEJ;;AAlEA;EACE,kBAAA;AAqEF;AApEE;EACE,gBAAA;AAsEJ;AApEE;EACE,kBAAA;AAsEJ;AApEE;EACE,oBAAA;AAsEJ;AApEE;EACE,kBAAA;AAsEJ;AApEE;EACE,kBAAA;AAsEJ;AApEE;EACE,kBAAA;AAsEJ;AApEE;EACE,kBAAA;AAsEJ;;AAnEA;EACE,mBAAA;AAsEF;;AApEA;EACE,cAAA;AAuEF;;AArEA;EACE,cAAA;AAwEF;;AAtEA;EACE,QAAA;AAyEF;;AAvEA;EACE,QAAA;AA0EF;;AAxEA;EACE,UAAA;AA2EF;;AAzEA;EACE,YAAA;AA4EF;;AA1EA;EACE,YAAA;AA6EF;;AA3EA;EACE,cAAA;AA8EF;;AA5EA;EACE,cAAA;AA+EF;;AA7EA;EACE,cAAA;AAgFF;;AA7EA;EACE,cAAA;EACA,gBAAA;EACA,YAAA;AAgFF;;AA9EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;AAiFF;;AA/EA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAkFF;;AA/EA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;AAkFF;;AA/EA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;AAkFF;;AAhFA;EACE,SAAA;AAmFF;;AAhFA;EACE,0BAAA;AAmFF;;AAhFA;EACE,kDAAA;AAmFF;;AAjFA;EACE,uDAAA;AAoFF;;AAlFA;EACE,wDAAA;AAqFF;;AAlFA;EACE,yDAAA;EACA,WAAA;AAqFF;;AAlFA;EACE,aAAA;AAqFF;;AAnFA;EACE,eAAA;AAsFF;;AApFA;EACE,cAAA;AAuFF;;AArFA;EACE,oCAAA;AAwFF;;AAtFA;EACE,YAAA;AAyFF;;AAvFA;EACE,mBAAA;AA0FF;;AAxFA;EACE,kBAAA;AA2FF;;AAzFA;EACE,mBAAA;AA4FF;;AA1FA;EACE,mBAAA;AA6FF;;AA3FA;EACE,kBAAA;AA8FF;;AA1FE;EACE,wDAAA;AA6FJ;;AAzFA;EACE,kBAAA;AA4FF;AA3FE;EACE,iBAAA;AA6FJ;;AAzFA;EACE,kDAAA;AA4FF;;AAxFA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AA2FF;;AAzFA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,sBAAA;EACA,kDAAA;EACA,mBAAA;EACA,SAAA;AA4FF;;AA1FA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,YAAA;EACA,aAAA;AA6FF;;AA3FA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,iDAAA;EAEA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA6FF;;AA3FA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iDAAA;EAEA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA6FF;;AA3FA;EACE,iBAAA;AA8FF;;AA3FE;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,cC1gCe;ADwmCnB;;AA3FA;EACE,eAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AA8FF;;AA5FA;EACE,SAAA;AA+FF;;AA7FA;EACE,gBAAA;EACA,sBAAA;AAgGF;;AA3FA;EACE,UAAA;EACA,gBAAA;AA8FF;;AA3FA;EACE,gBAAA;AA8FF;;AA3FA;EACE,kBAAA;AA8FF;;AA3FA;EACE,kBAAA;AA8FF;;AA3FA;EACE,gBAAA;AA8FF;;AA3FA;EACE,gBAAA;AA8FF;AA7FE;EACE,aAAA;AA+FJ;;AA5FA;EACE,iBAAA;AA+FF;;AA7FA;EACE,kBAAA;AAgGF;;AA9FA;EACE,eAAA;AAiGF;;AA/FA;EACE,kBAAA;AAkGF;;AAhGA;EACE,gBAAA;AAmGF;;AAjGA;EACE,gBAAA;AAoGF;;AAlGA;EACE,gBAAA;AAqGF;;AAnGA;EACE,kBAAA;AAsGF;;AApGA;EACE,gBAAA;AAuGF;;AArGA;EACE,WAAA;AAwGF;;AAtGA;EACE,kBAAA;AAyGF;;AAvGA;EACE,kBAAA;AA0GF;;AAvGA;EACE,aAAA;AA0GF;;AAvGA;EACE,qCAAA;AA0GF;;AAxGA;EACE,qCAAA;AA2GF;;AAzGA;EACE,qCAAA;AA4GF;;AA1GA;EACE,gDAAA;AA6GF;;AA3GA;EACE,uBAAA;AA8GF;;AA5GA;EACE,kCAAA;AA+GF;;AA7GA;EACE,uCAAA;EACA,WAAA;AAgHF;;AA9GA;EACE,kBAAA;AAiHF;;AA/GA;EACE,eAAA;AAkHF;;AAhHA;EACE,YAAA;AAmHF;;AAjHA;EACE,cAAA;AAoHF;;AAlHA;EACE,gBAAA;AAqHF;;AAnHA;EACE,YAAA;AAsHF;;AAnHA;EACE,WAAA;EACA,gBAAA;AAsHF;;AAnHA;EACE,WAAA;EACA,gBAAA;AAsHF;;AAnHA;EACE,YAAA;EACA,gBAAA;AAsHF;AApHE;EAJF;IAKI,gBAAA;EAuHF;AACF;AAtHE;EAPF;IAQI,gBAAA;EAyHF;AACF;AAvHE;EACE,gBAAA;AAyHJ;;AArHA;EACE,gBAAA;AAwHF;AAtHE;EAHF;IAII,gBAAA;EAyHF;AACF;AAxHE;EANF;IAOI,gBAAA;EA2HF;AACF;AAzHE;EACE,sBAAA;AA2HJ;;AAvHA;EACE,aAAA;EACA,iBAAA;AA0HF;AAxHE;EACE,sBAAA;EACA,gBAAA;AA0HJ;;AAtHA;EACE,WAAA;EACA,eAAA;AAyHF;AAvHE;EAJF;IAKI,WAAA;EA0HF;AACF;AAzHE;EAPF;IAQI,WAAA;EA4HF;AACF;;AAzHA;EACE,WAAA;AA4HF;;AAxHE;EADF;IAEI,cAAA;EA4HF;AACF;AA3HE;EAJF;IAKI,eAAA;EA8HF;AACF;AA5HE;EARF;IASI,eAAA;EA+HF;AACF;;AA5HA;EACE,kBAAA;EACA,UAAA,EAAA,iBAAA;EACA,YAAA,EAAA,iBAAA;EACA,kDAAA,EAAA,eAAA;AA+HF;;AA5HA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA,EAAA,iCAAA;EACA,2BAAA;EACA,YAAA;EACA,UAAA;EACA,kDAAA;AA+HF;;AA5HA;EACE,gBAAA;AA+HF;;AA5HA;EACE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AA+HF;;AA5HA;EACE,kDAAA;AA+HF;;AA3HE;EACE,gBAAA;EACA,wBAAA;EACA,0BAAA;EACA,SAAA;AA8HJ;AA5HE;EACE,gBAAA;EACA,wBAAA;EACA,0BAAA;EACA,SAAA;AA8HJ;;AA1HA;EACE,yDAAA;EAEA,yBAAA;EACA,8CAAA;AA4HF;AA1HE;EACE,iMAAA;AA4HJ;;AAxHA;EACE,aCryCY;ADg6Cd;;AAxHA;EACE,gBAAA;EACA,0BAAA;AA2HF;;AAxHA;EACE,uBAAA;EAAA,kBAAA;AA2HF;;AAxHA;EACE,OAAA;AA2HF;;AAzHA;EACE,MAAA;AA4HF;;AAxHE;EACE,gBAAA;AA2HJ;;AAvHA;EACE,kBAAA;AA0HF;;AAxHA;EACE,eAAA;EACA,gBAAA;AA2HF;;AAzHA;EACE,oBAAA;EACA,YAAA;AA4HF;;AAzHA;EACE,YAAA;EACA,oBAAA;AA4HF;;AA1HA;EACE,YAAA;AA6HF;;AA1HA;EACE,yBAAA;EACA,cAAA;AA6HF;;AA3HA;EACE,cCv1CY;ADq9Cd;;AA3HA;EACE;IACE,mBAAA;IACA,UAAA;EA8HF;EA5HA;IACE,sBAAA;IACA,YAAA;EA8HF;EA5HA;IACE,mBAAA;IACA,UAAA;EA8HF;AACF;AA3HA;EACE,0CAAA;AA6HF;;AA1HA;EACE,UAAA;AA6HF;;AA1HA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AA6HF;;AA1HA;EACE,QAAA;EACA,WAAA;AA6HF;;AA3HA;EACE,OAAA;EACA,YAAA;AA8HF;;AA5HA;EACE,MAAA;EACA,aAAA;AA+HF;;AA7HA;EACE,SAAA;EACA,UAAA;AAgIF;;AA7HA;EACE,oBAAA;AAgIF;;AA7HA;EACE,yBAAA;EACA,+BAAA;EACA,0DAAA;AAgIF;;AA7HA;EACE;IAEE,sBCr5CU;IDs5CV,+BAAA;EA+HF;EA5HA;IACE,0BAAA;IACA,gBAAA;EA8HF;AACF;AA3HA;EACE,0BAAA;EACA,mDAAA;AA6HF;;AA1HA;EACE;IACE,0BAAA;EA6HF;AACF;AA1HA;EACE,gBAAA;AA4HF;;AAzHA;EACE,eAAA;AA4HF;;AAzHA;EACE,wDAAA;AA4HF;;AAzHA;EACE,gBAAA;EACA,MAAA;EACA,OAAA;AA4HF;;AAzHA;EACE,kBAAA;AA4HF;;AAzHA;EACE,eAAA;EACA,MAAA;EACA,OAAA;AA4HF;;AAzHA;EACE,YAAA;AA4HF;;AAzHA;EACE,kBCx7Ca;ED07Cb,0BAAA;EACA,kBAAA;EACA,yFAAA;EACA,gEAAA;AA2HF;AAzHE;EACE,oIAAA;AA2HJ;AAxHI;EACE,sBAAA;AA0HN;AAtHE;EACE,kBAAA;EACA,cCv9CQ;EDw9CR,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBC/8CW;EDg9CX,sEAAA;AAwHJ;;AApHA;EACE,uDAAA;AAuHF;;AAnHA;EACE,gBAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;AAsHF;;AAnHA;EACE,yBAAA;EACA,YAAA;AAsHF;;AAnHA;EACE,yBAAA;AAsHF;;AAnHA;EACE,gBAAA;EACA,YAAA;EACA,mDAAA;EACA,kBAAA;EACA,iBAAA;AAsHF;;AApHA;EACE,YAAA;AAuHF;;AApHA;EACE,cAAA;AAuHF;;AApHA;EACE,eAAA;AAuHF;AAtHE;EACE,iBAAA;AAwHJ;;AApHA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AAuHF;;AApHA;EACE,kDAAA;AAuHF;;AApHA;EACE,0FCjgDa;ADwnDf;AArHE;EACE,yFCngDgB;AD0nDpB;;AApHA;EACE,YAAA;AAuHF;;AApHA;EACE,aAAA;AAuHF;;AApHA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;AAuHF;;AApHA;EACE,aAAA;EACA,yBAAA;EACA,WAAA;AAuHF;;AArHA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AAwHF;;AArHA;EACE,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,WAAA;AAwHF;;AArHA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBCrlDa;AD6sDf;;AAtHA;EACE,6BAAA;AAyHF;;AAtHA;EACE,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AAyHF;;AAvHA;EACE,UAAA;AA0HF;;AAvHA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;AA0HF;;AAvHA;EACE,cChnDY;AD0uDd;;AAvHA;EACE,YAAA;AA0HF;;AAvHA;EACE,eAAA;AA0HF;;AAxHA;EACE,mBAAA;AA2HF;;AAxHA;EACE,gBAAA;AA2HF;;AAxHA;EACE,cCnoDY;AD8vDd;;AAzHA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AA4HF;;AA1HA;EACE,gBAAA;AA6HF;;AA1HA;EACE,cCzoDU;ED0oDV,gBAAA;EACA,eAAA;EACA,gBAAA;AA6HF;;AA1HE;EACE,kDAAA;AA6HJ","sourcesContent":["@import \"../Components/App/index.scss\";\n@import \"../Components/App/vars.scss\";\n\n.appIcon {\n  width: 1.5em;\n  height: 1.5em;\n}\n.pageMainContainer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  padding-top: 0.5rem;\n  padding-bottom: 1rem;\n  flex-grow: 1;\n  align-self: stretch;\n  overflow: auto;\n}\n.control__btn {\n  position: absolute;\n  bottom: 0.5em;\n  // margin-top: 1em;\n  right: 1.5em;\n}\n.btn_container {\n  display: flex;\n  gap: 2em;\n  margin-bottom: 1em;\n  &.left {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n.two-column-page__container {\n  height: 100%;\n  display: flex;\n  position: relative;\n  width: 100%;\n\n  .right-side {\n    max-width: 50%;\n    padding-left: 1%;\n\n    display: flex;\n    height: 100%;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  .left-side {\n    padding-right: 1%;\n    border-right: 1px solid#426ca62a;\n    max-width: 50%;\n\n    display: flex;\n    height: 100%;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  .save_btns {\n    color: #567db8;\n    button {\n      margin-top: 10px;\n      margin-left: 10px;\n      font-weight: 400;\n      color: #567db8;\n      border: 0;\n      &:disabled {\n        color: #567db869;\n        background: #dae1ec8a;\n        cursor: default;\n      }\n    }\n  }\n  hr {\n    border-top: 0.01px solid #2d6dc757;\n    width: 100%;\n    margin-left: 0;\n    color: #426ba6;\n  }\n}\n.right_side_btn {\n  margin: 0 0 0 auto;\n  &.bottom {\n    margin: 0 0 1em auto;\n  }\n  &.top {\n    margin: 1em 0 0 auto;\n  }\n  &.top_and_bottom {\n    margin: 1em 0 1em auto;\n  }\n}\n\n@media (max-width: 1334px) {\n  .create_kp_cof_buttons_row {\n    .right_side_btn {\n      margin-left: 0;\n      flex: 1 1 100%;\n    }\n  }\n}\n\n//label\n.label {\n  align-items: center;\n  &_thin {\n    color: #88a5cf;\n    font-size: 12px;\n    font-style: italic;\n    font-weight: 400;\n    margin-right: 5px;\n  }\n  &.underline {\n    text-decoration: underline;\n  }\n  &.autolabel {\n    width: min-content;\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: keep-all;\n    white-space: nowrap; /* Запретить перенос текста по строчке */\n    display: inline-block;\n  }\n}\n.autolabel {\n  label:not(.switch-custom__toggle) {\n    width: min-content;\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: keep-all;\n    white-space: nowrap; /* Запретить перенос текста по строчке */\n    display: inline-block;\n    width: auto;\n  }\n}\n\n.overFlowAuto {\n  overflow: auto;\n}\n\n.overflowX {\n  overflow-x: auto;\n\n  &hidden {\n    overflow-x: hidden;\n  }\n}\n.overflowY {\n  overflow-y: auto;\n\n  &hidden {\n    overflow-y: hidden;\n  }\n}\n\n.labelWrap {\n  white-space: nowrap;\n}\n\n.tac {\n  text-align: center;\n}\n\n// .tableTac {\n//   tr td {\n//     text-align: center;\n//   }\n// }\n\n.bgc {\n  background-color: #dae1ec8a;\n}\n.bgcActive {\n  background-color: #bfcde2;\n}\n\n.project_form {\n  height: 100%;\n}\n\n.list_container {\n  width: 100%;\n  height: 120px;\n  overflow-x: hidden;\n  background: #ffffff;\n  margin-bottom: 5px;\n\n  border: #426ca681;\n}\n\n//grid\n.grid2_2 {\n  display: grid;\n  grid-template: 1fr 1fr / 1fr 1fr;\n}\n.grid2_3 {\n  display: grid;\n  grid-template: 1fr 1fr / 1fr 1fr 1fr 1fr;\n}\n.grid2_4 {\n  display: grid;\n  grid-template: 1fr 1fr / 1fr 1fr 1fr 1fr;\n  width: 100%;\n  column-gap: 10px;\n}\n.grid2_4lastAuto {\n  display: grid;\n  grid-template: 1fr 1fr / 1fr 1fr 1fr auto;\n  width: 100%;\n  column-gap: 10px;\n}\n.grid3_2 {\n  display: grid;\n  grid-template: 1fr 1fr / 1fr 1fr 1fr;\n}\n.grid2_5 {\n  display: grid;\n  grid-template: 1fr 1fr / 1fr 1fr 1fr 1fr 1fr;\n  width: 100%;\n  column-gap: 10px;\n}\n.grid2_5lastAuto {\n  display: grid;\n  grid-template: 1fr 1fr / 1fr 1fr 1fr 1fr auto;\n  width: 100%;\n  column-gap: 1rem;\n  row-gap: 1rem;\n}\n.gridTemplate2_4 {\n  grid-template: 1fr 1fr / 1fr 1fr 1fr auto;\n}\n.grid4col3Bigger {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr) 2fr 1fr;\n  gap: 10px;\n}\n.grid5col {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 10px;\n}\n\n.projectDireciveListFiltersContainer {\n  display: grid;\n  column-gap: 20px;\n  row-gap: 10px;\n  width: 100%;\n  grid-template-areas:\n    \"directiveNumber cofSecondNumber operationTypeId dateStart\"\n    \"statusId sumPlan payerData payerData dateEnd\";\n  align-items: center;\n  justify-items: end;\n}\n\n.invoiceListFiltersContainer {\n  display: grid;\n  column-gap: 20px;\n  row-gap: 10px;\n  width: 100%;\n  grid-template-areas:\n    \"invoiceNumber clientId clientId coId dateStart\"\n    \"sumPlan payerData payerData payerData dateEnd\";\n  align-items: center;\n  justify-items: stretch;\n}\n\n.settingsVedListFiltersContainer {\n  display: grid;\n  column-gap: 20px;\n  row-gap: 10px;\n  width: 100%;\n  grid-template-areas:\n    \"factoryId groupId typeId note dateStart\"\n    \"countryId manager1Id manager2Id manager3Id dateEnd\";\n  align-items: center;\n  justify-items: end;\n}\n\n.saleRulesFiltersContainer {\n  display: grid;\n  column-gap: 20px;\n  row-gap: 10px;\n  width: 100%;\n  grid-template-areas:\n    \"typeK conditionType manager dateStart\"\n    \"note note status dateEnd\";\n  align-items: center;\n  justify-items: end;\n}\n\n.dealerDiscountListFiltersContainer {\n  display: grid;\n  column-gap: 20px;\n  width: 50%;\n  grid-template-areas:\n    \"fabricCoef fabricCoefCondition fabricCoef2 fabricCoefCondition2\"\n    \"logistCoef logistCoefCondition logistCoef2 logistCoefCondition2\"\n    \"renCoef renCoefCondition renCoef2 renCoefCondition2\";\n  align-items: center;\n  justify-items: center;\n}\n\n.grid4col {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n}\n\n.gridTemplate2Rows {\n  grid-template-rows: 1fr 1fr;\n}\n.gridTemplate2RowsFirstMin {\n  grid-template-rows: 1fr 2fr;\n}\n.gridTemplate3ColsFirstMin {\n  grid-template-columns: 1fr 2fr 2fr;\n}\n\n// .grid2_5 {\n//   display: grid;\n//   grid-template: 2fr 1fr / 1fr 1fr 1fr 1fr auto;\n//   width: 100%;\n//   column-gap: 10px;\n// }\n.grid2Col {\n  display: grid;\n  grid-template: 1fr / repeat(2, 1fr);\n  column-gap: 10px;\n  width: 100%;\n}\n.grid2ColWithDivider {\n  display: grid;\n  grid-template: 1fr / repeat(2, 1fr);\n  column-gap: 10px;\n  width: 100%;\n  position: relative;\n\n  &::before {\n    position: absolute;\n    top: 5px;\n    left: 50%;\n    content: \"\";\n    height: calc(100% - 2 * 5px);\n    width: 1px;\n    background-color: #a3b9d9;\n  }\n}\n.grid2ColFirstBigger {\n  display: grid;\n  grid-template: 1fr / 2fr 1fr;\n  column-gap: 10px;\n  width: 100%;\n}\n.grid2ColSecondBigger {\n  display: grid;\n  grid-template: 2fr / 1fr 1fr;\n  column-gap: 10px;\n  width: 100%;\n}\n.grid2ColSecondMax {\n  display: grid;\n  grid-template: 1fr / 1fr auto;\n  column-gap: 10px;\n  width: 100%;\n}\n.grid3Col {\n  display: grid;\n  grid-template: 1fr / repeat(3, 1fr);\n  column-gap: 10px;\n  width: 100%;\n}\n.grid3ColMiddleMax {\n  display: grid;\n  grid-template: 1fr / auto 1fr auto;\n  column-gap: 10px;\n  width: 100%;\n}\n.grid3ColMiddleBigger {\n  display: grid;\n  grid-template: 1fr / 1fr 2fr 1fr;\n  column-gap: 10px;\n  width: 100%;\n}\n.rowGap {\n  row-gap: 1rem;\n}\n\n.grid3ColFirstMajor {\n  display: grid;\n  grid-template: 1fr / 1.5fr repeat(2, 1fr);\n  column-gap: 10px;\n  width: 100%;\n}\n.jsfe {\n  justify-self: flex-end;\n}\n\n/// flex\n.flex_form {\n  display: flex;\n  flex-direction: column;\n}\n\n.flex_container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.fc {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.fc {\n  display: flex;\n  align-items: center;\n  // justify-content: space-between;\n\n  &.col {\n    flex-direction: column;\n  }\n\n  .fi50 {\n    flex-basis: 50%;\n  }\n  .fi60 {\n    flex-basis: 60%;\n  }\n  .fi70 {\n    flex-basis: 70%;\n  }\n}\n.jsstr {\n  justify-self: stretch;\n}\n.row {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  // align-items: center;\n  gap: 5px;\n}\n.flexWrap {\n  flex-wrap: wrap;\n}\n.column {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 5px;\n}\n\n.relative {\n  position: relative;\n}\n.capitalize {\n  text-transform: capitalize;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.w100 {\n  width: 100%;\n}\n.mw100 {\n  max-width: 100%;\n}\n\n.wh100 {\n  width: 100%;\n  height: 100%;\n}\n\n.w50 {\n  width: 50%;\n}\n\n.h100 {\n  height: 100%;\n}\n\n.maxH100 {\n  max-height: 100%;\n}\n\n.inactive {\n  background-color: transparent;\n  color: rgba(86, 125, 184, 0.41);\n\n  table th {\n    color: rgba(86, 125, 184, 0.41);\n  }\n}\n\n.fdr {\n  display: flex;\n  flex-direction: row;\n}\n\n.f_block {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.f_f_block {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1.8rem;\n  width: 87%;\n}\n\n.f_f_block_small {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1.8rem;\n}\n\n.f_block_item_normal {\n  flex-basis: calc(25% - 20px);\n}\n\n.f_block_item_less {\n  flex-basis: calc(33% - 20px);\n}\n\n.f_item_opacity {\n  opacity: 50%;\n}\n\n.fdc {\n  display: flex;\n  flex-direction: column;\n}\n\n.fcCol {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.fcCols {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.fcc {\n  display: flex;\n  // flex-wrap: nowrap;\n  flex-direction: row;\n  align-items: center;\n}\n.nowrap {\n  flex-wrap: nowrap;\n}\n.wrap {\n  flex-wrap: wrap;\n}\n.space-between {\n  justify-content: space-between;\n}\n.jcsb {\n  justify-content: space-between;\n}\n.jcse {\n  justify-content: space-evenly;\n}\n.jcsa {\n  justify-content: space-around;\n}\n.jcc {\n  justify-content: center;\n}\n.jcfe {\n  justify-content: flex-end;\n}\n.jcfs {\n  justify-content: flex-start;\n}\n.aic {\n  align-items: center;\n}\n.aife {\n  align-items: flex-end;\n}\n.aist {\n  align-items: flex-start;\n}\n.aibl {\n  align-items: baseline;\n}\n.aistr {\n  align-items: stretch;\n}\n.asstr {\n  align-self: stretch;\n}\n.asfs {\n  align-self: flex-start;\n}\n.asfe {\n  align-self: flex-end;\n}\n.asc {\n  align-self: center;\n}\n.fd {\n  flex-direction: column;\n}\ndiv.noGapDiv {\n  gap: 0;\n}\n.noGap {\n  gap: 0;\n}\n.asfs {\n  align-self: flex-start;\n}\n.gap {\n  gap: 1rem;\n}\n.gap0_5 {\n  gap: 0.5rem;\n}\n.gap2x {\n  gap: 2rem;\n}\n.gap3x {\n  gap: 3rem;\n}\n.gap4x {\n  gap: 4rem;\n}\n.gap5x {\n  gap: 5rem;\n}\n.gap7x {\n  gap: 7rem;\n}\n.gap10x {\n  gap: 10rem;\n}\n.gap1 {\n  gap: 1px;\n}\n.gap2 {\n  gap: 2px;\n}\n.gap5 {\n  gap: 5px;\n}\n.halfBasis {\n  flex-basis: 50%;\n}\n.mba {\n  margin-bottom: auto;\n}\n.mb0 {\n  margin-bottom: 0;\n}\n.mb0_5 {\n  margin-bottom: 0.5rem;\n}\n.mb {\n  margin-bottom: 1rem;\n}\n.mb5 {\n  margin-bottom: 5px;\n}\n.mb2x {\n  margin-bottom: 2rem;\n}\n.mb3x {\n  margin-bottom: 3rem;\n}\n.ml {\n  margin-left: 1em;\n  &5 {\n    margin-left: 5px;\n  }\n  &_05 {\n    margin-left: 0.5em;\n  }\n  &2x {\n    margin-left: 2em;\n  }\n  &3x {\n    margin-left: 3em;\n  }\n  &_auto {\n    margin-left: auto;\n  }\n}\n.mr {\n  margin-right: 1em;\n  &_05 {\n    margin-right: 0.5em;\n  }\n  &2x {\n    margin-right: 2em;\n  }\n}\n.ml10em {\n  margin-left: 10em;\n}\n.padding1 {\n  padding: 1px;\n}\n\n.padding5 {\n  padding: 5px;\n}\n\n.pt {\n  padding-top: 1rem;\n\n  &0 {\n    padding-top: 0;\n  }\n  &0_5 {\n    padding-top: 0.5rem;\n  }\n  &3 {\n    padding-top: 3px;\n  }\n  &5 {\n    padding-top: 5px;\n  }\n  &2x {\n    padding-top: 2rem;\n  }\n}\n.pb {\n  padding-bottom: 1rem;\n\n  &0 {\n    padding-bottom: 0;\n  }\n  &5 {\n    padding-bottom: 5px;\n  }\n  &10 {\n    padding-bottom: 10px;\n  }\n  &0_5 {\n    padding-bottom: 0.5rem;\n  }\n  &1_5 {\n    padding-bottom: 1.5rem;\n  }\n  &2x {\n    padding-bottom: 2rem;\n  }\n}\n\n.pb2 {\n  padding-bottom: 2rem;\n}\n.pl {\n  padding-left: 1em;\n  &0 {\n    padding-left: 0;\n  }\n  &5 {\n    padding-left: 5px;\n  }\n  &_05 {\n    padding-left: 0.5em;\n  }\n  &1_5x {\n    padding-left: 1.5em;\n  }\n  &2x {\n    padding-left: 2em;\n  }\n  &3x {\n    padding-left: 3em;\n  }\n  &4x {\n    padding-left: 4em;\n  }\n  &5x {\n    padding-left: 5em;\n  }\n  &6x {\n    padding-left: 6em;\n  }\n  &7x {\n    padding-left: 7em;\n  }\n}\n.pr {\n  padding-right: 1em;\n  &0 {\n    padding-right: 0;\n  }\n  &5 {\n    padding-right: 5px;\n  }\n  &_05 {\n    padding-right: 0.5em;\n  }\n  &2x {\n    padding-right: 2em;\n  }\n  &3x {\n    padding-right: 3em;\n  }\n  &5x {\n    padding-right: 5em;\n  }\n  &7x {\n    padding-right: 7em;\n  }\n}\n.paddingRight {\n  padding-right: 1rem;\n}\n.noShrink {\n  flex-shrink: 0;\n}\n.fShrink {\n  flex-shrink: 1;\n}\n.g2 {\n  gap: 2em;\n}\n.g1 {\n  gap: 1em;\n}\n.g15 {\n  gap: 1.5em;\n}\n.fGrow {\n  flex-grow: 1;\n}\n.fGrow2 {\n  flex-grow: 2;\n}\n.fShrink {\n  flex-shrink: 1;\n}\n.fShrink2 {\n  flex-shrink: 2;\n}\n.fShrink2 {\n  flex-shrink: 3;\n}\n///////////\n.page_container {\n  padding: 0 1em;\n  padding-top: 5px;\n  height: 100%;\n}\n.page_flex_container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  justify-content: flex-start;\n  gap: 1em;\n}\n.form_wrapper {\n  width: 100%;\n  min-width: 100%;\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow-x: visible;\n  position: relative;\n}\n\n.period-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  gap: 10px;\n}\n\n.request-date-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin: 0;\n  gap: 1.2em;\n}\n.flex0 {\n  flex: 0;\n}\n\n.underlined {\n  text-decoration: underline;\n}\n\n.borderInput {\n  border: 1px solid #426ca681;\n}\n.borderLeft {\n  border-left: 1px solid #426ca681;\n}\n.borderRight {\n  border-right: 1px solid #426ca681;\n}\n\n.border_bottom_container {\n  border-bottom: 1px solid #426ca681;\n  width: 100%;\n}\n\n.padding {\n  padding: 1rem;\n}\n.padding0_5 {\n  padding: 0.5rem;\n}\n.margin0_5 {\n  margin: 0.5rem;\n}\n.buttonPaddings {\n  padding: 0.5rem 0.8rem 0.5rem 0.8rem;\n}\n.paddingMin {\n  padding: 5px;\n}\n.paddingRight {\n  padding-right: 1rem;\n}\n.paddingLeft {\n  padding-left: 1rem;\n}\n.paddingTop {\n  padding-right: 1rem;\n}\n.paddingBottom {\n  padding-right: 1rem;\n}\n.br {\n  border-radius: 3px;\n}\n\n.borderMiddle {\n  &:not(:last-child) {\n    border-right: 1px solid #426ca681;\n  }\n}\n\n.paddingMiddle {\n  padding-right: 1em;\n  &:not(:first-child) {\n    padding-left: 1em;\n  }\n}\n\n.thin_border_container {\n  border: 1px solid #426ca681;\n}\n///////////\n\n.imgPreview {\n  width: 100%;\n  min-width: 600px;\n  height: 100%;\n  padding: 1em 2em;\n  padding-bottom: 3em;\n  box-sizing: border-box;\n}\n.previewBox {\n  width: 100%;\n  height: auto;\n  min-height: 250px;\n  max-width: 920px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  padding: 20px 20px;\n  box-sizing: border-box;\n  border: dashed 3px #426ca65e;\n  border-radius: 10px;\n  gap: 10px;\n}\n.previewBoxItem {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  object-fit: contain;\n  border: 1px solid #426ca65e;\n  width: 200px;\n  height: 200px;\n}\n.previewBoxItem__del {\n  position: absolute;\n  top: 0;\n  right: -4px;\n  border: 1px solid #426ca65e;\n\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background-color: aliceblue;\n  font-size: 18px;\n  line-height: 18px;\n  font-weight: 300;\n  margin-top: -5px;\n  cursor: pointer;\n}\n.previewBoxItem__crop {\n  position: absolute;\n  bottom: 0;\n  right: -4px;\n  border: 1px solid #426ca65e;\n\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background-color: aliceblue;\n  font-size: 18px;\n  line-height: 18px;\n  font-weight: 300;\n  margin-top: -5px;\n  cursor: pointer;\n}\n.previewBoxItem img {\n  object-fit: cover;\n}\n.previewBoxItem.fileDeleted {\n  &::after {\n    content: \"Deleted\";\n    position: absolute;\n    top: 55%;\n    left: 10%;\n    font-size: 52px;\n    transform: rotate(-45deg);\n    width: 125px;\n    color: $deletedTextColor;\n  }\n}\n.imgPreview__buttons {\n  position: fixed;\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n  bottom: 10px;\n  right: 5px;\n  align-items: center;\n}\n.img-adding {\n  border: 0;\n}\n.cropper_container {\n  padding: 1em 2em;\n  box-sizing: border-box;\n}\n/////\n\n//list\n.list {\n  padding: 0;\n  list-style: none;\n}\n\n.hideOverflow {\n  overflow: hidden;\n}\n\n.scrollOverflow {\n  overflow-y: scroll;\n}\n\n.centeredText {\n  text-align: center;\n}\n\n.toBottom {\n  margin-top: auto;\n}\n\n.mt {\n  margin-top: 1rem;\n  &0 {\n    margin-top: 0;\n  }\n}\n.mla {\n  margin-left: auto;\n}\n.mra {\n  margin-right: auto;\n}\n.mt5 {\n  margin-top: 5px;\n}\n.mt0_5 {\n  margin-top: 0.5rem;\n}\n.mt1x {\n  margin-top: 1rem;\n}\n.mt2x {\n  margin-top: 2rem;\n}\n.mt3x {\n  margin-top: 3rem;\n}\n.mr {\n  margin-right: 1rem;\n}\n.scrollY {\n  overflow-y: auto;\n}\n.fullWidth {\n  width: 100%;\n}\n.pr {\n  position: relative;\n}\n.pa {\n  position: absolute;\n}\n\n.dg {\n  display: grid;\n}\n\n.col3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n.col4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n.col5 {\n  grid-template-columns: repeat(5, 1fr);\n}\n.col4FirstBiggerLastSmaller {\n  grid-template-columns: 2fr repeat(2, 1fr) 0.75fr;\n}\n.rows1 {\n  grid-template-rows: 1fr;\n}\n.rows2 {\n  grid-template-rows: repeat(2, 1fr);\n}\n.col3-proc {\n  grid-template-columns: repeat(3, 32.5%);\n  width: 100%;\n}\n.tac {\n  text-align: center;\n}\n.tae {\n  text-align: end;\n}\n.center {\n  margin: auto;\n}\n.centerX {\n  margin: 0 auto;\n}\n.bottom {\n  margin-top: auto;\n}\n.h100 {\n  height: 100%;\n}\n\n.modal_sizes {\n  width: 89vw;\n  min-height: 20vh;\n}\n\n.modal_sizes_preview {\n  width: 91vw;\n  min-height: 40vh;\n}\n\n.smallModal {\n  width: 800px;\n  min-height: 50vh;\n\n  @media screen and (min-width: 1800px) {\n    min-height: 45vh;\n  }\n  @media screen and (min-width: 2600px) {\n    min-height: 40vh;\n  }\n\n  & .modal_form__child {\n    min-width: unset;\n  }\n}\n\n.largeModal {\n  max-height: 90vh;\n\n  @media screen and (min-width: 1800px) {\n    max-height: 80vh;\n  }\n  @media screen and (min-width: 2600px) {\n    max-height: 70vh;\n  }\n\n  .modal_form__child {\n    flex-direction: column;\n  }\n}\n\n.xsModal {\n  height: 300px;\n  min-height: 300px;\n\n  .modal_form__child {\n    flex-direction: column;\n    min-width: 700px;\n  }\n}\n\n.tabModal {\n  height: 85%;\n  max-height: 95%;\n\n  @media screen and (min-width: 1024px) {\n    width: 85vw;\n  }\n  @media screen and (min-width: 2600px) {\n    width: 70vw;\n  }\n}\n\n.largeTabModal {\n  height: 95%;\n}\n\n.smaller_font_size {\n  @media screen and (min-width: 1024px) and (max-width: 1439px) {\n    font-size: 7px;\n  }\n  @media screen and (min-width: 1440px) and (max-width: 1799px) {\n    font-size: 11px;\n  }\n\n  @media screen and (min-width: 1800px) {\n    font-size: 14px;\n  }\n}\n\n.vertical-line {\n  position: relative;\n  width: 1px; /* Ширина линии */\n  height: 100%; /* Высота линии */\n  background-color: #426ca681; /* Цвет линии */\n}\n\n.vertical-line::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 50%; /* Расположение линии по центру */\n  transform: translateX(-50%);\n  height: 100%;\n  width: 1px;\n  background-color: #426ca681;\n}\n\n.hidden {\n  overflow: hidden;\n}\n\n.hiddenEl {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  border: 0;\n  clip: rect(0 0 0 0);\n}\n\n.borderedInput {\n  border: 1px solid #426ca681;\n}\n\n.inputTypeNumberNoArrows {\n  &::-webkit-outer-spin-button {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: textfield;\n    margin: 0;\n  }\n  &::-webkit-inner-spin-button {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: textfield;\n    margin: 0;\n  }\n}\n\n.accented {\n  transition: box-shadow 0.3s $transitionFunc;\n\n  border: 1px solid #ff073a;\n  box-shadow: rgba(255, 7, 58, 0.25) 1px 2px 2px;\n\n  &:hover {\n    box-shadow: rgba(255, 7, 58, 0.25) 2px 4px 4px, rgba(255, 7, 58, 0.12) -2px -3px 3px,\n      rgba(255, 7, 58, 0.12) 0px 4px 4px, rgba(255, 7, 58, 0.17) 0px 4px 4px, rgba(255, 7, 58, 0.09) 0px -3px 3px;\n  }\n}\n.accentedIcon {\n  fill: $accentColor;\n}\n\n.header {\n  font-weight: 500;\n  text-decoration: underline;\n}\n\n.fitContentWidth {\n  width: fit-content;\n}\n\n.l0 {\n  left: 0;\n}\n.t0 {\n  top: 0;\n}\n\n.leftPlaceholder {\n  &::placeholder {\n    text-align: left;\n  }\n}\n\n.italic {\n  font-style: italic;\n}\n.small-text {\n  font-size: 12px;\n  font-weight: 300;\n}\n.disabled-div {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.blur {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.blurWithEvents {\n  opacity: 0.5;\n}\n\n.accentedTableCell {\n  background-color: #d6dde7;\n  color: #567db8;\n}\n.accentedRedTableCell {\n  color: $accentColor;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.05);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.pulse {\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n.p0 {\n  padding: 0;\n}\n\n.absolute {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.absolute.right {\n  right: 0;\n  left: unset;\n}\n.absolute.left {\n  left: 0;\n  right: unset;\n}\n.absolute.top {\n  top: 0;\n  bottom: unset;\n}\n.absolute.bottom {\n  bottom: 0;\n  top: unset;\n}\n\n.readOnlyInput {\n  pointer-events: none;\n}\n\n.accentBtn {\n  border: 1px solid $accentColor;\n  box-shadow: 3px 3px 1px $accentColor;\n  transition: border 0.2s ease-out, box-shadow 0.2s ease-out;\n}\n\n@keyframes temporaryAccentFade {\n  0%,\n  60% {\n    outline-color: $accentColor;\n    box-shadow: 3px 3px 1px $accentColor;\n  }\n\n  100% {\n    outline-color: transparent;\n    box-shadow: none;\n  }\n}\n\n.temporaryAccentBtn {\n  outline: 1px solid $accentColor;\n  animation: temporaryAccentFade 4s ease-out forwards;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .temporaryAccentBtn {\n    animation-duration: 0.01ms;\n  }\n}\n\n.normalWeight {\n  font-weight: 400;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.contextMenuCursor {\n  cursor: url(\"../images/icons/context_menu.png\"), pointer;\n}\n\n.sticky {\n  position: sticky;\n  top: 0;\n  left: 0;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n.btnNoFuntional {\n  opacity: 50%;\n}\n\n.filtersTopContainer {\n  border-radius: $borderRadius;\n  // margin-bottom: 3px;\n  padding: 2px 10px 10px 2px;\n  position: relative;\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n  transition: box-shadow 0.35s cubic-bezier(0.075, 0.82, 0.565, 1);\n\n  &:hover {\n    box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,\n      rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;\n\n    & .filtersTitle {\n      background-color: #fff;\n    }\n  }\n\n  & .filtersTitle {\n    position: absolute;\n    color: $textColor;\n    top: -7px;\n    left: 80px;\n    font-size: 12px;\n    padding: 1px 5px;\n    border-radius: $borderRadius;\n    transition: background-color 0.35s cubic-bezier(0.075, 0.82, 0.565, 1);\n  }\n}\n\n.snakePdfPreviewBorder {\n  border-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='100' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cstyle%3Epath%7Banimation:stroke 5s infinite linear%3B%7D%40keyframes stroke%7Bto%7Bstroke-dashoffset:776%3B%7D%7D%3C/style%3E%3ClinearGradient id='g' x1='0%25' y1='0%25' x2='0%25' y2='100%25'%3E%3Cstop offset='0%25' stop-color='%2398FB98' /%3E%3Cstop offset='25%25' stop-color='%23A7F434' /%3E%3Cstop offset='50%25' stop-color='%23A7F434' /%3E%3Cstop offset='100%25' stop-color='%2332CD32' /%3E%3C/linearGradient%3E %3Cpath d='M1.5 1.5 l97 0l0 97l-97 0 l0 -97' stroke-linecap='square' stroke='url(%23g)' stroke-width='3' stroke-dasharray='388'/%3E %3C/svg%3E\")\n    1;\n}\n\n.stickyTableRowItem {\n  position: sticky;\n  left: 0;\n  z-index: 20;\n  background-color: white;\n}\n\n.accent-row {\n  background-color: #567db8;\n  color: white;\n}\n\n.accent-cell {\n  border: 1px solid $accentColor;\n}\n\n.notesTable {\n  overflow-x: auto;\n  height: 5rem;\n  border: 1px solid rgba(163, 185, 217, 0.5960784314);\n  font-style: italic;\n  padding-left: 8px;\n}\n.noteTableContact {\n  height: 4rem;\n}\n\n.notesTable.factory-new-contact-notes-table {\n  height: 5.25em;\n}\n\n.notesTableTr {\n  cursor: pointer;\n  td {\n    white-space: wrap;\n  }\n}\n\n.note-block {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 0.5em;\n}\n\n.transitionAll {\n  transition: all 0.3s $transitionFunc;\n}\n\n.commonShadow {\n  box-shadow: $commonShadow;\n\n  &:hover {\n    box-shadow: $commonShadowHover;\n  }\n}\ninput[type=\"radio\"]:disabled {\n  opacity: 0.5;\n}\n\n.styles-table {\n  height: 44rem;\n}\n\n.date-delivery {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.history-box {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n}\n.manager-btn-wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 9rem;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  height: 100%;\n}\n\n.orderFullSection-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 340px;\n  grid-template-rows: auto 1fr;\n  gap: 0 1rem;\n}\n\n.cicle-check {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 17px;\n  height: 17px;\n  border-radius: 100%;\n  background-color: $tableBgColor;\n}\n.cicle-disabled {\n  background-color: transparent;\n}\n\n.visually-hidden {\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  border: 0;\n  padding: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(100%);\n  margin: -1px;\n}\n.w50p {\n  width: 50%;\n}\n\n.question-input {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 1px;\n  left: 1px;\n  margin-left: 0;\n}\n\n.accentText {\n  color: $accentColor;\n}\n\n.widthUnset {\n  width: unset;\n}\n\n.defaultCursor {\n  cursor: default;\n}\n.notAllowedCursor {\n  cursor: not-allowed;\n}\n\n.mta {\n  margin-top: auto;\n}\n\n.required-asterisk {\n  color: $accentColor;\n}\n.shipment-data {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.minWidthUnset {\n  min-width: unset;\n}\n\n.context-menu-text {\n  color: $textColor;\n  font-weight: 400;\n  cursor: pointer;\n  font-size: 1.1em;\n}\n.hoverRow {\n  &:hover {\n    background-color: #426ca62f;\n  }\n}\n","$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$borderColorLight: #dae1ec;\n$accentFilterColor: #ff8040;\n$accentColor: #b72025;\n$warningColor: #d3c71c;\n$succesColor: #00dbbb;\n$accentTableRowColor: #ecc0c1;\n$filtersBgColor: #d6dfea71; //#d6dfea\n$filterTitleColor: #d6dfea93;\n$textColor: #426ba6;\n$filtersBorderColor: #426ba6;\n$deletedTextColor: #b72025;\n$iconFill: #829ec4;\n$logoIcon: #6d91c6;\n$activeBtnColor: rgba(218, 225, 236, 1);\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n$btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;\n$reactTableShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;\n$dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;\n$commonShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$commonShadowHover: rgba(67, 71, 85, 0.27) 1px 1px 0.25em, rgba(90, 125, 188, 0.05) 1px 0.3em 1em;\n\n$transition: ease;\n$transitionFunc: cubic-bezier(0.25, 1, 0.5, 1);\n$iconHoverTransition: cubic-bezier(0.22, 1, 0.36, 1);\n$commonTransition: 0.3s $transitionFunc;\n\n:root {\n  --filterBtnBoxShadow: #{$filterBtnBoxShadow};\n  --btnBoxShadow: #{$btnBoxShadow};\n  --btnHoverBoxShadow: #{$btnHoverBoxShadow};\n  --dividerShadow: #{$dividerShadow};\n}\n\n$main-font: \"Roboto\", sans-serif;\n\n$font-weights: (\n  \"Light\": 300,\n  \"Regular\": 400,\n  \"Medium\": 500,\n  \"Bold\": 700,\n);\n","@import \"./mixins.scss\";\n@import \"./vars.scss\";\n@import \"./functions.scss\";\n\n/* Скрывает только iframe оверлея ошибок, который вешается прямо на body */\nbody > iframe[style*=\"z-index: 2147483647\"],\nbody > iframe[style*=\"fixed\"] {\n  display: none !important;\n}\n\n/* Альтернативный селектор для новых версий react-error-overlay */\n#webpack-dev-server-client-overlay,\ndiv[style*=\"z-index: 2147483647\"] {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
